import React from 'react';
import propTypes from 'prop-types';

import PaginationSummaries from '../../../components/Paginations/PaginationSummaries';
import { Tbl, TblHead, TblBody } from '../../../components/Tbl';
import { HTTP_STATUS } from '../../../constants/kickavenue';
import RowItem from './RowItem';
import { TableResponsive } from '../styled';

// Widths are the design's 70/400/250/180/160/78 over its 1138px table, kept as
// percentages so they hold at any card width.
const columns = [
  { header: 'No.', style: { width: '6.15%' } },
  { header: 'Review', style: { width: '35.15%' } },
  { header: 'Product / SKU', style: { width: '21.97%' } },
  { header: 'Invoice', style: { width: '15.82%' } },
  { header: 'Status', style: { width: '14.06%' } },
  { header: 'Action', style: { width: '6.85%' } }
];

const dataHeader = columns.map(column => column.header);

const List = props => {
  const { list, isLoading, detailRoute } = props;
  const rows = Array.isArray(list.data)? list.data: [];
  const hasRow = list.status_code === HTTP_STATUS.OK && rows.length > 0;

  return (
    <TableResponsive className="table-responsive" ref={props.innerRefs}>
      <PaginationSummaries
        from={list.from}
        to={list.to}
        total={list.total}
      />
      <Tbl>
        <colgroup>
          { columns.map(column => <col key={column.header} style={column.style}/>) }
        </colgroup>
        <TblHead dataHeader={dataHeader}/>
        <TblBody
          isLoad={isLoading}
          hasRow={hasRow}
          columnCount={columns.length}
          renderChildren={() => rows.map(item => (
            <RowItem
              key={item.id}
              item={item}
              detailRoute={detailRoute}
            />
          ))}
        />
      </Tbl>
    </TableResponsive>
  )
}

export default List;

List.propTypes = {
  list: propTypes.object,
  isLoading: propTypes.bool,
  detailRoute: propTypes.string.isRequired,
  innerRefs: propTypes.oneOfType([propTypes.func, propTypes.object])
}

List.defaultProps = {
  list: {},
  isLoading: false
}
